import RouterBase from '../../../components/navigation/RouterBase';
import { URLAPP } from '../../../config';
import TicketsOperations from './TicketsOperations';

export default function TicketsOperation() {
    return (
        <RouterBase
            items={[
                {
                    component: <TicketsOperations />,
                    fullPath: URLAPP.tickets,
                    path: ":id",
                    nestedRouter: true
                }
            ]}
        />
    )
}
